import React from 'react';
import BadPrimariesWarning from 'ui/sections/asset-beneficiaries/pages/BadPrimariesWarning';

export default class SpouseBadPrimariesWarning extends BadPrimariesWarning {
  static forSpouse = true;
}
